import styled from "@emotion/styled";
import { Theme, Typography } from "@yuno/design-system-web";
import { useTranslation } from "react-i18next";

const CARD_ICON = "https://icons.prod.y.uno/card_logosimbolo.png";

const Container = styled.div<{ theme?: Theme }>`
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  padding-left: 24px;
  padding-right: 24px;
  margin-left: 24px;
  margin-right: 24px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
`;

const Item = styled.div<{ theme?: Theme; borderless?: boolean }>`
  padding-top: 24px;
  padding-bottom: 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid
    ${({ theme, borderless }) =>
      borderless ? theme.palette.grey[2] : "transparent"};

  & img {
    margin-right: 16px;
    width: 30px;
    height: 30px;
    object-fit: fill;
  }
`;

export const PreviewItemList = ({ data, hasCard = false }) => {
  const { t } = useTranslation();

  return (
    <Container>
      {hasCard && (
        <Item borderless={true}>
          <img src={CARD_ICON} />
          <Typography>{t('addCard')}</Typography>
        </Item>
      )}
      {data
        .filter(({ is_active }) => is_active)
        .map((el, key) => (
          <Item key={key} borderless={key !== data.length - 1}>
            <img src={el.icon} />
            {el.payment_method_type === "CARD" ? (
              "****1234"
            ) : (
              <Typography>{el.short_name || el.name}</Typography>
            )}
          </Item>
        ))}
    </Container>
  );
};
